import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import toFragment from 'rc-util/lib/Children/mapSelf';
import MonthPanel from '../month/MonthPanel';
import YearPanel from '../year/YearPanel';
import DecadePanel from '../decade/DecadePanel';

function noop() {}

function goMonth(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'months');
  this.props.onValueChange(next);
}

function goYear(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'years');
  this.props.onValueChange(next);
}

function showIf(condition, el) {
  return condition ? el : null;
}

var CalendarHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(CalendarHeader, _React$Component);

  var _super = _createSuper(CalendarHeader);

  function CalendarHeader(_props) {
    var _this;

    _classCallCheck(this, CalendarHeader);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "onMonthSelect", function (value) {
      // TODO: 通过picker简化配置
      var originMode = _this.props.originMode;
      var currentPanel = "date";

      if (originMode && originMode.includes("month")) {
        currentPanel = "month";
      } else if (originMode && originMode.includes("year")) {
        currentPanel = "year";
      }

      _this.props.onPanelChange(value, currentPanel);

      if (_this.props.onMonthSelect) {
        _this.props.onMonthSelect(value);
      } else {
        _this.props.onValueChange(value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onYearSelect", function (value) {
      // TODO: 通过picker简化配置
      var originMode = _this.props.originMode;
      var currentPanel = "date";

      if (originMode && originMode.includes("month")) {
        currentPanel = "month";
      } else if (originMode && originMode.includes("year")) {
        currentPanel = "year";
      }

      var referer = _this.state.yearPanelReferer;
      if (originMode) referer = currentPanel;

      _this.setState({
        yearPanelReferer: null
      });

      _this.props.onPanelChange(value, referer);

      if (_this.props.onYearSelect) {
        _this.props.onYearSelect(value);
      } else {
        _this.props.onValueChange(value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDecadeSelect", function (value) {
      _this.props.onPanelChange(value, 'year');

      _this.props.onValueChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "monthYearElement", function (showTimePicker) {
      var props = _this.props;
      var prefixCls = props.prefixCls;
      var locale = props.locale;
      var value = props.value;
      var localeData = value.localeData && value.localeData();
      var monthBeforeYear = locale.monthBeforeYear;
      var selectClassName = "".concat(prefixCls, "-").concat(monthBeforeYear ? 'my-select' : 'ym-select');
      var timeClassName = showTimePicker ? " ".concat(prefixCls, "-time-status") : '';
      var year = /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-year-select").concat(timeClassName),
        role: "button",
        onClick: showTimePicker ? null : function () {
          return _this.showYearPanel('date');
        },
        title: showTimePicker ? null : locale.yearSelect
      }, value.format(locale.yearFormat));
      var month = /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-month-select").concat(timeClassName),
        role: "button",
        onClick: showTimePicker ? null : _this.showMonthPanel,
        title: showTimePicker ? null : locale.monthSelect
      }, locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value));
      var day;

      if (showTimePicker) {
        day = /*#__PURE__*/React.createElement("a", {
          className: "".concat(prefixCls, "-day-select").concat(timeClassName),
          role: "button"
        }, value.format(locale.dayFormat));
      }

      var my = [];

      if (monthBeforeYear) {
        my = [month, day, year];
      } else {
        my = [year, month, day];
      }

      return /*#__PURE__*/React.createElement("span", {
        className: selectClassName
      }, toFragment(my));
    });

    _defineProperty(_assertThisInitialized(_this), "showMonthPanel", function () {
      // null means that users' interaction doesn't change value
      _this.props.onPanelChange(null, 'month');
    });

    _defineProperty(_assertThisInitialized(_this), "showYearPanel", function (referer) {
      _this.setState({
        yearPanelReferer: referer
      });

      _this.props.onPanelChange(null, 'year');
    });

    _defineProperty(_assertThisInitialized(_this), "showDecadePanel", function () {
      _this.props.onPanelChange(null, 'decade');
    });

    _this.nextMonth = goMonth.bind(_assertThisInitialized(_this), 1);
    _this.previousMonth = goMonth.bind(_assertThisInitialized(_this), -1);
    _this.nextYear = goYear.bind(_assertThisInitialized(_this), 1);
    _this.previousYear = goYear.bind(_assertThisInitialized(_this), -1);
    _this.state = {
      yearPanelReferer: null
    };
    return _this;
  }

  _createClass(CalendarHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var prefixCls = props.prefixCls,
          locale = props.locale,
          mode = props.mode,
          value = props.value,
          showTimePicker = props.showTimePicker,
          enableNext = props.enableNext,
          enablePrev = props.enablePrev,
          disabledMonth = props.disabledMonth,
          renderFooter = props.renderFooter,
          onChange = props.onChange,
          onClear = props.onClear,
          autoTriggerChange = props.autoTriggerChange,
          showMonthInput = props.showMonthInput;
      var calendarProps = {};

      if (autoTriggerChange) {
        calendarProps.value = value;
        calendarProps.onChange = onChange;
      } else {
        calendarProps.onChange = noop;
      }

      var panel = null;

      if (mode === 'month') {
        panel = /*#__PURE__*/React.createElement(MonthPanel, _extends({
          showDateInput: true,
          locale: locale,
          showMonthInput: showMonthInput,
          defaultValue: value,
          rootPrefixCls: prefixCls,
          onSelect: this.onMonthSelect,
          onYearPanelShow: function onYearPanelShow() {
            return _this2.showYearPanel('month');
          },
          disabledDate: disabledMonth,
          cellRender: props.monthCellRender,
          contentRender: props.monthCellContentRender,
          renderFooter: renderFooter,
          onClear: onClear
        }, calendarProps));
      }

      if (mode === 'year') {
        panel = /*#__PURE__*/React.createElement(YearPanel, {
          locale: locale,
          defaultValue: value,
          rootPrefixCls: prefixCls,
          onSelect: this.onYearSelect,
          onDecadePanelShow: this.showDecadePanel,
          renderFooter: renderFooter
        });
      }

      if (mode === 'decade') {
        panel = /*#__PURE__*/React.createElement(DecadePanel, {
          locale: locale,
          defaultValue: value,
          rootPrefixCls: prefixCls,
          onSelect: this.onDecadeSelect,
          renderFooter: renderFooter
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-header")
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        },
        className: "".concat(prefixCls, "-header-btns")
      }, showIf(enablePrev && !showTimePicker, /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-prev-year-btn"),
        role: "button",
        onClick: this.previousYear,
        title: locale.previousYear
      })), showIf(enablePrev && !showTimePicker, /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-prev-month-btn"),
        role: "button",
        onClick: this.previousMonth,
        title: locale.previousMonth
      })), this.monthYearElement(showTimePicker), showIf(enableNext && !showTimePicker, /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-next-month-btn"),
        onClick: this.nextMonth,
        title: locale.nextMonth
      })), showIf(enableNext && !showTimePicker, /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-next-year-btn"),
        onClick: this.nextYear,
        title: locale.nextYear
      }))), panel);
    }
  }]);

  return CalendarHeader;
}(React.Component);

_defineProperty(CalendarHeader, "propTypes", {
  prefixCls: PropTypes.string,
  value: PropTypes.object,
  onValueChange: PropTypes.func,
  showTimePicker: PropTypes.bool,
  onPanelChange: PropTypes.func,
  locale: PropTypes.object,
  enablePrev: PropTypes.any,
  enableNext: PropTypes.any,
  disabledMonth: PropTypes.func,
  renderFooter: PropTypes.func,
  onMonthSelect: PropTypes.func,
  onYearSelect: PropTypes.func
});

_defineProperty(CalendarHeader, "defaultProps", {
  enableNext: 1,
  enablePrev: 1,
  onPanelChange: function onPanelChange() {},
  onValueChange: function onValueChange() {}
});

export { CalendarHeader as default };


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/calendar/CalendarHeader.js